import { Row } from "antd";
import styled from "styled-components";

export const Content = styled("p")`
  margin: 1rem 0 1rem 0;
  color: #ffffff;
`;

export const StyledRow = styled(Row)`
  flex-direction: ${({ direction }: { direction: string }) =>
    direction === "left" ? "row" : "row-reverse"};
`;

export const MinPara = styled("p")`
  font-size: 13px;
`;

export const ContentSection = styled("section")`
  position: relative;
  padding: 2rem 0 2rem;

  @media only screen and (max-width: 1024px) {
    padding: 0.7rem 0 0.7rem;
  }
`;

export const FlexContainer = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const ServiceWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
`;

export const Badge = styled.span.attrs(({ className: 'bold-font' }))`
  color: #995cf9ff;
  text-transform: uppercase;
  font-size: 1.2em;
  font-weight: 800;
  letter-spacing: 0.1rem;
  background-color: #232328ff;
  padding: 5px 10px;
  border-radius: 12px;
`;

export const BulletPointsList = styled("div")`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const BulletPoint = styled("div")`
  color: #FFFFFF;
  display: flex;
  gap: 1.2rem;
`;

export const BulletTitle = styled("div")`
  font-size: 1.2rem;
  font-weight: 700;
`;

export const BulletDescription = styled("div")`
  font-size: 1.05rem;
  font-weight: 400;
`;

export const IconWrapper = styled("span")`
  display: flex;
  align-items: center;

  .anticon {
    color: #8d49fb;
    background: rgb(35, 35, 40);
    padding:1rem;
    border-radius: 50%;
    border: 1px solid #8d49fb;
  }
`;

export const ContentWrapper = styled("div")`
  position: relative;
  max-width: 540px;
  margin-bottom: 1.5rem;

  @media only screen and (max-width: 575px) {
    padding-top: 1.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const BlockContentWrapper = styled("div")`
  position: relative;

  @media only screen and (max-width: 575px) {
    padding-top: 4rem;
  }
`;

export const H6White = styled("h6")`
  color: #FFFFFF;
  margin-bottom: 0;
  font-size: 2.5rem;
`;

export const MinTitle = styled("h6")`
  font-size: 15px;
  line-height: 1rem;
  padding: 0.5rem 0;
  text-transform: uppercase;
  color: #000;
  font-family: "Rajdhani Light", sans-serif;
`;

export const ButtonWrapper = styled("div")`
  display: flex;
  gap: 5;
  max-width: 100%;
  flex-wrap: wrap;

  @media screen and (min-width: 1024px) {
    max-width: 80%;
  }

  button:last-child {
    margin-left: 20px;
  }
`;

export const BulletPointsWrapper = styled("div")`
  display: flex;
  gap: 2em;
  justify-content: flex-start;
  padding: 1.2em 0;
  margin-top: 0.7rem;
  flex-wrap: wrap;
`;

export const IconBulletPoint = styled("span")`
  display: flex;
  color: #ffffffff;
  text-transform: uppercase;
  font-size: 0.9em;
  letter-spacing: 0.1rem;

  .anticon {
    margin-right: 0.3em;
    font-size: 1.5em;
    color: #995cf9ff;
  }
`;

export const H6Purple = styled("h6")`
  color: #8d49fb;
  margin-bottom: 0;
  font-size: 2.4rem;
`;

export const ContentBlock = styled("div")`
  position: relative;
  text-align: center;
`;
